import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import CategoriesContainer from '../../containers/admin/CategoriesContainer';

interface CategoriesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CategoriesModal: React.FC<CategoriesModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('admin');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" placement="center" backdrop="blur" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">{t('categories.manageTitle', { defaultValue: 'Manage Categories' })}</ModalHeader>
        <ModalBody className="pb-6">
          <CategoriesContainer />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CategoriesModal;

